export const copy = (text) => {
  if (typeof navigator?.clipboard?.writeText === 'function') {
    return navigator?.clipboard?.writeText(text);
  } else {
    return new Promise((resolve, reject) => {
      try {
        let getTextDom = document.createElement('textarea');
        getTextDom.value = text;
        document.body.appendChild(getTextDom);
        getTextDom.select();
        document.execCommand('Copy');
        getTextDom.remove();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
};
